import React, { useState } from 'react';

import classes from './shop-detail-home.module.scss';
import { Languages } from '@/lib/dictionaries';

const information: { [key: string]: any } = {
  ko: [
    {
      title: '국내 배송',
      contents: [
        {
          subject: '배송방식',
          body: '주식회사 글로브웨이브 물류센터 직접배송',
        },
        {
          subject: '배송지역',
          body:
            '전국(일부지역 제외) ・배송비용 : 3,000원  \n' +
            '주문금액 별 50,000원 이상 시 무료배송  \n' +
            '- 도서산간지역은 추가 배송비가 발생할 수 있습니다.  ',
        },
        {
          subject: '배송기간',
          body:
            '결제 후 5~10일 이내 (영업일 기준) \n' +
            '예약판매의 경우 배송 시작일 기준 5~10일 이내(영업일 기준) \n' +
            '\n' +
            '- 상품의 재고상황에 따라 배송기간이 다소 지연될 수도 있습니다. \n' +
            '\n' +
            '- 물류센터 사정으로 인해 배송이 지연될 수 있습니다. \n' +
            '\n' +
            '- 예약판매 상품 등 당일 배송이 어려운 상품을 함께 구매하는 경우 \n' +
            '모든 상품이 배송 가능한 상태가 되는 시점에 주문하신 상품이 함께 배송됩니다. \n' +
            '(상품별 배송일정이 상이하오니 자세한 일정은 상품 상세페이지를 참고 바랍니다.)  \n' +
            '\n' +
            '- 기본 배송기간 이상 소요되는 상품이거나 품절된 상품은 개별 연락 드리겠습니다. ',
        },
      ],
    },
    {
      title: '해외 배송',
      contents: [
        {
          subject: '배송방식',
          body: '주식회사 글로브웨이브 물류센터 직접배송 (우체국 EMS)  ',
        },
        {
          subject: '배송지역',
          body: '글로벌 배송 (불가능한 지역 확인은 CS 팀에게 문의 바랍니다.) ',
        },
        {
          subject: '배송기간',
          body:
            '결제 후 5~10일 이내 (영업일 기준) \n' +
            '예약판매의 경우 배송 시작일 기준 5~10일 이내(영업일 기준) \n' +
            '\n' +
            '- 상품의 재고상황에 따라 배송기간이 다소 지연될 수도 있습니다. \n' +
            '\n' +
            '- 물류센터 사정으로 인해 배송이 지연될 수 있습니다. \n' +
            '\n' +
            '- 예약판매 상품 등 당일 배송이 어려운 상품을 함께 구매하는 경우 \n' +
            '모든 상품이 배송 가능한 상태가 되는 시점에 주문하신 상품이 함께 배송됩니다. \n' +
            '(상품별 배송일정이 상이하오니 자세한 일정은 상품 상세페이지를 참고 바랍니다.)  \n' +
            '\n' +
            '- 기본 배송기간 이상 소요되는 상품이거나 품절된 상품은 개별 연락 드리겠습니다. ',
        },
      ],
    },
  ],
  ja: [
    {
      title: '国内配送',
      contents: [
        {
          subject: '配送方法',
          body: '株式会社グローブウェーブ物流センターからの直接配送（郵便局またはCJ大韓通運）',
        },
        {
          subject: '配送地域',
          body: '全国（一部地域を除く）',
        },
        {
          subject: '配送料',
          body:
            '3,000ウォン、注文金額が50,000ウォン以上の場合は無料配送 \n' +
            '\n' +
            '離島や山間部では追加送料が発生することがあります。 \n' +
            '\n' +
            '配送期間: 決済後5〜10営業日以内 \n' +
            '予約販売の場合は、配送開始日から5〜10営業日以内。 \n' +
            '\n' +
            '商品の在庫状況により、配送期間が多少遅れる場合があります。 \n' +
            '\n' +
            '物流センターの都合により、配送が遅れることがあります。 \n' +
            '\n' +
            '予約販売商品など、当日配送が難しい商品を一緒に購入する場合、すべての商品が配送可能な状態になった時点でご注文いただいた商品が一緒に配送されます。 \n' +
            '（商品ごとの配送スケジュールが異なるため、詳細なスケジュールについては商品詳細ページをご参照ください。） \n' +
            '\n' +
            '基本の配送期間を超える時間がかかる商品や品切れの商品については、個別にご連絡いたします。',
        },
      ],
    },
    {
      title: '海外配送',
      contents: [
        {
          subject: '配送方法',
          body: '株式会社グローブウェーブ物流センターからの直接配送（郵便局EMS）',
        },
        {
          subject: '配送地域',
          body: 'グローバル配送（配送できない地域についてはCSチームにお問い合わせください。）',
        },
        {
          subject: '配送期間',
          body:
            '決済後5〜10営業日以内 \n' +
            '予約販売の場合は、配送開始日から5〜10営業日以内。 \n' +
            '\n' +
            '商品の在庫状況により、配送期間が多少遅れる場合があります。 \n' +
            '\n' +
            '物流センターの都合により、配送が遅れることがあります。 \n' +
            '\n' +
            '予約販売商品など、当日配送が難しい商品を一緒に購入する場合、すべての商品が配送可能な状態になった時点でご注文いただいた商品が一緒に配送されます。 \n' +
            '（商品ごとの配送スケジュールが異なるため、詳細なスケジュールについては商品詳細ページをご参照ください。） \n' +
            '\n' +
            '基本の配送期間を超える時間がかかる商品や品切れの商品については、個別にご連絡いたします。 ',
        },
      ],
    },
  ],
  en: [
    {
      title: 'Domestic Shipping',
      contents: [
        {
          subject: 'Shipping Method',
          body: 'Direct delivery from GlobeWave Logistics Center (Korea Post or CJ Logistics)',
        },
        {
          subject: 'Shipping Area',
          body:
            'Nationwide (excluding some areas) \n' +
            '\n' +
            'Shipping Fee: 3,000 KRW, free shipping for orders over 50,000 KRW \n' +
            '\n' +
            'Additional shipping charges may apply for remote island and mountainous areas. ',
        },
        {
          subject: 'Shipping Period',
          body:
            'Within 5–10 business days after payment \n' +
            'For pre-orders, shipping will be within 5–10 business days from the start of shipping. \n' +
            '\n' +
            'The shipping period may be slightly delayed depending on the stock status of the product. \n' +
            '\n' +
            'Delivery may be delayed due to logistics center circumstances. \n' +
            '\n' +
            'If you purchase items that cannot be shipped immediately, such as pre-order products, all items will be shipped together when they are available for shipping. \n' +
            '(Shipping schedules may vary by product, so please refer to the product detail page for specific schedules.) \n' +
            '\n' +
            'For items that require longer than the standard shipping period or are out of stock, we will contact you individually. \n' +
            ' ',
        },
      ],
    },
    {
      title: 'International Shipping',
      contents: [
        {
          subject: 'Shipping Method',
          body: 'Direct delivery from GlobeWave Logistics Center (Korea Post EMS)',
        },
        {
          subject: 'Shipping Area',
          body: 'Global shipping (Please contact the CS team to check regions where shipping is unavailable.)',
        },
        {
          subject: 'Shipping Period',
          body:
            'Within 5–10 business days after payment \n' +
            'For pre-orders, shipping will be within 5–10 business days from the start of shipping. \n' +
            '\n' +
            'The shipping period may be slightly delayed depending on the stock status of the product. \n' +
            '\n' +
            'Delivery may be delayed due to logistics center circumstances. \n' +
            '\n' +
            'If you purchase items that cannot be shipped immediately, such as pre-order products, all items will be shipped together when they are available for shipping. \n' +
            '(Shipping schedules may vary by product, so please refer to the product detail page for specific schedules.) \n' +
            '\n' +
            'For items that require longer than the standard shipping period or are out of stock, we will contact you individually. ',
        },
      ],
    },
  ],
  zh: [
    {
      title: '国际配送',
      contents: [
        {
          subject: '配送方式',
          body: '由GlobeWave物流中心直接发货（韩国邮政EMS、中国快递公司或其他全球快递公司）',
        },
        {
          subject: '配送地区',
          body: '全球配送（无法配送的地区请联系客户服务团队确认） \n',
        },
        {
          subject: '配送时间',
          body:
            '付款后5–10个工作日内发货，预售商品从开始发货日起5–10个工作日内配送。根据库存情况，配送时间可能会有所延迟。 \n' +
            '由于物流中心的情况，配送可能会延误。 \n' +
            '如果您购买了无法立即发货的商品（如预售商品），所有商品将在可配送时统一发货。（配送时间因商品而异，具体时间请参见商品详情页） \n' +
            '对于超出标准配送时间或缺货的商品，我们将与您单独联系。 ',
        },
      ],
    },
  ],
};

const copyrignt: any[] = [
  {
    title: '저작권 관련 유의사항',
    contents: [
      {
        subject: '저작권 준수',
        body: '당사에서 판매하는 모든 음반 및 음원 상품은 정식 라이선스를 받은 제품이며, 저작권법에 따라 적법하게 제작 및 유통되었습니다.',
      },
      {
        subject: '저작권 침해 금지',
        body: '고객은 음반 및 음원 상품을 개인 용도로만 사용해야 하며, 무단 복제, 배포, 변형 등의 행위를 금지합니다.',
      },
      {
        subject: '저작권 위반 상품의 정의',
        body: '저작권자의 허락 없이 복제되거나 배포된 상품, 혹은 정식 라이선스를 받지 않은 상품은 저작권 위반 상품으로 간주됩니다.',
      },
    ],
  },
  {
    title: '저작권 위반 상품 판매 시 환불 정책',
    contents: [
      {
        subject: '환불 절차',
        body: '저작권 위반 상품으로 확인된 경우, 구매 고객은 구매일로부터 30일 이내에 환불을 요청할 수 있습니다.',
      },
      {
        subject: '환불 조건',
        body: '저작권 위반 사실이 확인된 상품에 대해서는 구매 영수증과 상품 원본을 제출해 주셔야 하며, 검토 후 환불이 처리됩니다.',
      },
      {
        subject: '예외 사항',
        body: '고객의 과실로 인해 손상된 상품이나 이미 사용한 음반 및 음원 상품은 환불 대상에서 제외될 수 있습니다.',
      },
    ],
  },
];

function ShopDetailDeliveryInformation({ lang }: { lang: Languages }) {
  lang = lang === 'id' ? 'en' : lang;
  const [opens, setOpens] = useState<boolean[]>([true, true]);

  const handleToggleOpen = (index: number) => {
    setOpens(prev => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  function drawTitle(title: string, index: number) {
    return (
      <a
        className={classes.itemHeadBox}
        onClick={() => handleToggleOpen(index)}
      >
        {title}
      </a>
    );
  }

  return (
    <div className={classes.detailEtcGroup}>
      <div className={classes.etcList}>
        {information[lang].map(
          (
            item: {
              title: string;
              contents: { subject: string; body: string }[];
            },
            index: number,
          ) => (
            <div className={classes.etcItem} key={`order-delivery-${index}`}>
              {drawTitle(item.title, index)}
              <div
                className={classes.itemBodyBox}
                style={{ display: opens[0] ? 'block' : 'none' }}
              >
                <ul>
                  {item.contents.map(
                    (
                      content: { subject: string; body: string },
                      subIndex: number,
                    ) => (
                      <li key={`order-delivery-content-${subIndex}`}>
                        <div className={classes.itemWrap}>
                          <div className={classes.subjectBox}>
                            {content.subject.trim()}
                          </div>
                          <div className={classes.conBox}>
                            {content.body
                              .trim()
                              .replace(/\\r\\n|\\n|\\r/gm, '<br/>')}
                          </div>
                        </div>
                      </li>
                    ),
                  )}
                </ul>
              </div>
            </div>
          ),
        )}
        {lang === 'ko' &&
          copyrignt.map(
            (
              item: {
                title: string;
                contents: { subject: string; body: string }[];
              },
              index: number,
            ) => (
              <div className={classes.etcItem} key={`order-copyrignt-${index}`}>
                {drawTitle(item.title, index)}
                <div
                  className={classes.itemBodyBox}
                  style={{ display: opens[0] ? 'block' : 'none' }}
                >
                  <ul>
                    {item.contents.map(
                      (
                        content: { subject: string; body: string },
                        subIndex: number,
                      ) => (
                        <li key={`order-delivery-content-${subIndex}`}>
                          <div className={classes.itemWrap}>
                            <div className={classes.subjectBox}>
                              {content.subject.trim()}
                            </div>
                            <div className={classes.conBox}>
                              {content.body
                                .trim()
                                .replace(/\\r\\n|\\n|\\r/gm, '<br/>')}
                            </div>
                          </div>
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              </div>
            ),
          )}
      </div>
    </div>
  );
}

export default ShopDetailDeliveryInformation;
